export const SORT_LIST = {
  new: '최신순',
  minPrice: '낮은 가격순',
  maxPrice: '높은 가격순',
  maxScale: '넓은 면적순',
  minScale: '좁은 면적순',
  recommend: '추천순',
};

export type SortListTypeKey = keyof typeof SORT_LIST;

export const DANJI_SORT_LIST = {
  name: '이름순',
  maxHsehCount: '세대수 많은순',
  minBuildYear: '연식 낮은순',
  maxOfferings: '매물 많은순',
};

export type DanjiSortListTypeKey = keyof typeof DANJI_SORT_LIST;

export const REALTOR_SORT_LIST = {
  name: '가나다 순',
  distance: '가까운 순',
  recommend: '추천순',
};

export type RealtorSortListTypeKey = keyof typeof REALTOR_SORT_LIST;

export const QNA_SORT_LIST = {
  Q01: '이용 문의',
  Q02: '오류 문의',
  Q03: '계정 문의',
  Q04: '기타',
};

export type QnaSortListTypeKey = keyof typeof QNA_SORT_LIST;
